(function($) {
  'use strict';

  let $banner = $(".js-banner--image"),
      $bannerImage = $(".js-banner--image img");

  function initBanner() {

    $banner.stop().delay(300).animate({
      'opacity' : '1',
    }, 300);

    $bannerImage.stop().animate({
      'width' : '105%',
      'opacity' : '1',
    }, 1000);
  }

  window.addEventListener('load', initBanner);

})(jQuery);
